import styled from 'styled-components';
import { FormSelect } from 'medrefer-web-sdk/web-kit';

export const RepeatSelect = styled(FormSelect)`
    .Select__placeholder {
        color: ${({ theme }) => theme.black};
    }
`;
